module.exports = __webpack_public_path__ + "static/img/identification-sign-color-core.9f07e16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/wayfinding/identification-sign-color-core.jpg
// module id = 1050
// module chunks = 0